/*
 * @Description: 实时报到人数
 * @Version: 1.0
 * @Author: 琴时
 * @Date: 2021-09-03 09:57:09
 * @LastEditors: 琴时
 * @LastEditTime: 2021-09-13 16:51:42
 */
import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Form, Divider, Table } from 'antd'
import NHFetch from '../../utils/NHFetch.js'
import styles from './styles.css'
const yxxtBasicUrl = 'api/zhxg-yxxt' //迎新管理服务后台接口基础路径
const errMaxCount = 3 // 请求异常最大次数
const speed = 15 * 1000 //轮询时间间隔
const image = require('../../styles/images/stuDefault.png')
class _LeftTopBox extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      errCount: 0, //连续请求错误次数
      data: [], //环节办理统计数据
      index: 0,
      animate: false,
    }
    this.polling //轮询定时器
    this.polling1
  }

  componentDidMount() {
    this.getData()
  }

  componentWillUnmount() {
    //组件卸载时清除轮询定时器
    if (this.polling) {
      clearTimeout(this.polling)
    }
    if (this.polling1) {
      clearTimeout(this.polling1)
    }
  }

  changeAnim = () => {
    const { data, index } = this.state
    setTimeout(() => {
      data.push(data[0])
      data.shift()
      this.setState({
        index: data.length > 0 && index < data.length - 1 ? index + 1 : 0,
        data,
        animate: false,
      })
    }, 500)
  }

  /**
   * * 获取实时报到学生信息
   * @memberof Home
   */
  getData = () => {
    const { index } = this.state
    NHFetch(yxxtBasicUrl + '/sstj/getRealTimeReportedStudentInfoByLcid', 'GET',{pkid: this.props.pkid})
      .then(res => {
        if (res && res.data) {
          this.polling = setTimeout(() => {
            this.getData()
          }, speed)
          let data = res.data
          /* 模拟数据 */
          //TODO:模拟数据
          // data = [
          //   {
          //     xsid: '1',
          //     photo: '',
          //     xm: '张三封',
          //     zymc: '软件工程',
          //     byxx:'联奕中学',
          //     jg: '天河科韵路a座3楼联奕',
          //   },
          //   {
          //     xsid: '2',
          //     photo: '',
          //     xm: '张三丰',
          //     zymc: '计算机科技与信息管理',
          //     byxx:'联奕中学',
          //     jg: '天河科韵路',
          //   },
          //   {
          //     xsid: '3',
          //     photo: '',
          //     xm: '张三疯',
          //     zymc: '计算机科技与信息管理',
          //     byxx:'联奕中学',
          //     jg: '广东广州',
          //   },
          //   {
          //     xsid: '4',
          //     photo: '',
          //     xm: '张三锋',
          //     zymc: '计算机电子科学与技术实验',
          //     byxx:'联奕中学',
          //     jg: '天河科韵路a座3楼联奕',
          //   },
          //   {
          //     xsid: '5',
          //     photo: '',
          //     xm: '张三颠',
          //     zymc: '计算机开发工程实验 ',
          //     byxx:'联奕中学',
          //     jg: '广东茂名',
          //   },
          //   {
          //     xsid: '6',
          //     photo: '',
          //     xm: '张三颠2',
          //     zymc: '计算机开发 ',
          //     byxx:'联奕中学',
          //     jg: '广东茂名',
          //   },
          //   {
          //     xsid: '7',
          //     photo: '',
          //     xm: '张三颠3',
          //     zymc: '计算机开发 ',
          //     byxx:'联奕中学',
          //     jg: '广东茂名',
          //   },
          // ]
          let newData = []
          if (index > 0 && data.length > 0) {
            newData = data.splice(0, index)
            data.push(...newData)
          }
          this.setState({ errCount: 0, data })
          if (this.polling1) {
            clearTimeout(this.polling1)
          }
          this.polling1 = setInterval(() => {
            this.setState(
              {
                animate: true,
              },
              () => {
                this.changeAnim()
              }
            )
          }, 3000)
        }
      })
      .catch(err => {
        let errCount = this.state.errCount
        //如果请求异常次数未超过最大次数限制，则继续尝试
        if (errCount < errMaxCount) {
          this.polling = setTimeout(() => {
            this.getData()
          }, speed)
          this.setState({ errCount: errCount + 1 })
        } else {
          //异常超过3次后终止轮询
          if (this.polling) {
            clearTimeout(this.polling)
          }
        }
      })
  }
  render() {
    let { data = [] } = this.state
    let newData=[...data]
    if(data.length>4) newData.splice(4)
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
    }
    const columns = [
      {
        title: '头像',
        dataIndex: 'photo',
        key: 'photo',
        width: '50px',
        height: '50px',
        render: text => (
          <img
            src={text ? `data:image/jpeg;base64,${text}` : image}
            className='img'
            alt=''
          />
        ),
      },
      {
        title: '姓名',
        dataIndex: 'xm',
        key: 'xm',
        width: '60px',
      },
      {
        title: '专业',
        key: 'zymc',
        dataIndex: 'zymc',
      },
      {
        title: '籍贯',
        key: 'jg',
        dataIndex: 'jg',
      },
    ]
    return (
      <div className='leftTopBox' style={{ width: '100%', height: '100%' }}>
        <span className={styles.box_title}>实时报到人数</span>
        <div className={styles.box_space}>
          <Row className={styles.personal}>
            <Col span={4}>
              <img
                src={
                  data.length > 0 && data[0].photo
                    ? `data:image/jpeg;base64,${data[0].photo}`
                    : image
                }
                style={{ width: 55 }}
              />
            </Col>
            <Col span={20}>
              <Form {...formItemLayout}>
                <Form.Item
                  label={
                    <span className={styles.span_color_while}>姓名：</span>
                  }
                >
                  <span className={styles.span_color_blue}>
                    {data.length > 0 && data[0].xm}
                  </span>
                </Form.Item>
                <Form.Item
                  label={
                    <span className={styles.span_color_while}>专业：</span>
                  }
                >
                  <span className={styles.span_color_blue}>
                    {data.length > 0 && data[0].zymc}
                  </span>
                </Form.Item>
                <Form.Item
                  label={
                    <span className={styles.span_color_while}>籍贯：</span>
                  }
                >
                  <span className={styles.span_color_blue}>
                    {data.length > 0 && data[0].jg}
                  </span>
                </Form.Item>
                <Form.Item
                  label={
                    <span className={styles.span_color_while}>毕业学校：</span>
                  }
                >
                  <span className={styles.span_color_blue}>
                    {data.length > 0 && data[0].byxx}
                  </span>
                </Form.Item>
              </Form>
            </Col>
          </Row>
          <Divider dashed />
          <Table
            columns={columns}
            dataSource={newData}
            rowKey={row => row.xsid}
            pagination={false}
          />
        </div>
        <style jsx='true' global='true'>
          {`
            .leftTopBox {
              overflow: hidden;
            }
            .leftTopBox .ant-col-4 {
              width: 55px;
            }
            .leftTopBox .ant-form-item {
              margin-bottom: auto;
            }
            .leftTopBox path {
              fill:#04184b;
            }
            .leftTopBox .ant-form-item-control {
              line-height: 20px;
              margin-left: -15px;
            }
            .leftTopBox .ant-form-item-label {
              line-height: 20px;
            }
            .leftTopBox .ant-divider-horizontal {
              margin: 3px 0;
              border-color: #2ba8ff;
            }
            .leftTopBox .ant-table {
              color: #2ba8ff;
              font-size: 12px;
            }
            .leftTopBox .ant-table-placeholder {
              background: #04184b;
              border-top: 1px solid #071b4e;
              border-bottom: 1px solid #071b4e;
            }
            .leftTopBox .ant-empty-description {
              color: #fff;
            }

            .leftTopBox .ant-table-thead > tr > th {
              background: #0a1f51;
              color: #fff;
              font-size: 12px;
              border-bottom: 0px;
            }
            .leftTopBox .ant-table-tbody > tr > td {
              border-bottom: 0px;
            }
            .leftTopBox .img {
              width: 34px;
              height: 34px;
              border-radius: 50%;
            }
            .leftTopBox .ant-table-thead > tr > th,
            .ant-table-tbody > tr > td {
              padding: 5px 9px;
            }
          `}
        </style>
      </div>
    )
  }
}

_LeftTopBox.defaultProps = {}

_LeftTopBox.propTypes = {
  rem: PropTypes.number,
}

export default _LeftTopBox



// WEBPACK FOOTER //
// ./containers/Show-new/_LeftTopBox.js